import * as React from "react";
import {Fragment} from "react";
import JobWatcherChangeNotification from "../../../model/notification/watcher/JobWatcherChangeNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: JobWatcherChangeNotification
}

/**
 * Job watcher change notification toast body.
 */
const NotificationJobWatcherChangeBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>Job {props.notification.data.getJobReferenceNumber()}</div>
			<div className={"toast-body"}>
				Watcher(s) changed from <b>{props.notification.displayPreviousWatchers()} </b>
				to <b>{props.notification.displayCurrentWatchers()}</b>
			</div>
		</Fragment>
	);
};

export default NotificationJobWatcherChangeBody;